/* 金额转数字 */
let MoneyFormat = {
  install (Vue) {
    Vue.prototype.moneyFormat = function (money) {
      var num = money.trim()
      var ss = num.toString()
      if (ss.length === 0) {
        return 0.00
      }
      // eslint-disable-next-line no-new-wrappers
      num = new Number(ss.replace(/,/g, ''))
      return num
    }
  }
}
export default MoneyFormat



// WEBPACK FOOTER //
// ./src/plugins/MoneyFormat.js